<template>
  <div class="rating">
    <div class="stars">
      <span
          v-for="star in 5"
          :key="star"
          class="star"
      >
        <span class="star-bg">★</span>
        <span
            class="star-fill"
            :style="{ width: starFill(star) + '%' }"
        >★</span>
      </span>
    </div>

    <span class="rating-text">
      {{ decimal }} / 5
      <span v-if="feedbackCount">({{ feedbackCount }} {{ feedbackCount === 1 ? 'Bewertung' : 'Bewertungen'}})</span>
    </span>
  </div>
</template>

<script>
export default {
  name: "StarRating",
  props: {
    feedbackCount: {
      type: [String, Number],
      default: 0
    },
    feedbackDecimal: {
      type: [String, Number],
      required: true
    }
  },
  computed: {
    decimal() {
      return this.feedbackDecimal ? parseFloat(this.feedbackDecimal) : 0;
    }
  },
  methods: {
    starFill(star) {
      const diff = this.decimal - (star - 1);

      if (diff >= 1) return 100;
      if (diff > 0) return diff * 100;
      return 0;
    }
  }
};
</script>

